export class EncryptDecryptResponse{
public data:any
public iv: any
}